module.exports = __webpack_public_path__ + "img/iknowit@3x.339a65bc.png";